import { render, staticRenderFns } from "./Observer.vue?vue&type=template&id=60eaadee&scoped=true"
import script from "./Observer.vue?vue&type=script&lang=ts"
export * from "./Observer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eaadee",
  null
  
)

export default component.exports